/**
 * VechainHealthMetrics Component
 *
 * Health metrics panel for VeChain network.
 */

import { Icons } from '../Icons';
import { GenericHealthMetrics, networkConfigs } from '../common/GenericHealthMetrics';
import type { VechainNetworkMetrics } from '../../services/blockchainHealthApi';

const VET_COLOR = '#15BDFF';

function renderVechainMetrics(metrics: Record<string, any>) {
  const m = (metrics || {}) as VechainNetworkMetrics;
  return (
    <>
      {/* Authority Nodes */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Server size={24} style={{ color: VET_COLOR, marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: VET_COLOR }}>
          {m.activeNodes ?? 0}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Authority Nodes
        </div>
      </div>

      {/* Block Height */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Hash size={24} style={{ color: '#7B68EE', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#7B68EE' }}>
          {m.blockHeight ?? '0'}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Block Height
        </div>
      </div>

      {/* TPS */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Zap size={24} style={{ color: '#f59e0b', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#f59e0b' }}>
          {(m.tps ?? 0).toLocaleString()}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Max TPS
        </div>
      </div>

      {/* Block Time */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.Clock size={24} style={{ color: '#06b6d4', marginBottom: '8px' }} />
        <div style={{ fontSize: '24px', fontWeight: 700, color: '#06b6d4' }}>
          {m.avgBlockTime ?? 0}s
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          Block Time
        </div>
      </div>

      {/* VTHO Generation */}
      <div style={{
        padding: '16px',
        background: 'var(--border)',
        borderRadius: '12px',
        textAlign: 'center'
      }}>
        <Icons.TrendingUp size={24} style={{ color: '#2ECC71', marginBottom: '8px' }} />
        <div style={{ fontSize: '20px', fontWeight: 700, color: '#2ECC71' }}>
          {m.vthoGenerationRate ?? 0}
        </div>
        <div style={{ fontSize: '11px', color: 'var(--muted)', marginTop: '4px' }}>
          VTHO/VET/jour
        </div>
      </div>
    </>
  );
}

export function VechainHealthMetrics() {
  const config = {
    ...networkConfigs.vechain,
    renderNetworkMetrics: renderVechainMetrics,
  };

  return <GenericHealthMetrics config={config} />;
}
